import { useCallback, useMemo } from "react";
import { useTheme } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core";
import { useAtomicStyles } from "styles";
import { drawerWidth } from "styles/constants";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { actions, selectors } from "redux-store";
import { useCurrentMerchantId, useTypedTranslations } from "hooks";
import { push, replace } from "connected-react-router";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    appBar: {
      [theme.breakpoints.up("sm")]: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
      },
    },
    menuIcon: {
      color: "white",
    },
    barContainer: {
      display: "flex",
      width: "100%",
    },
    selectorContainer: {
      flexGrow: 1,
      textAlign: "center",
    },
    logoutButton: {
      marginTop: 0,
    },
    mobileLogoutButton: {
      marginTop: 5,
      marginRight: 10,
    },
  }),
);

const useDashboardAppBar = () => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const classes = useMemo(() => ({}), []);
  const atomicStyles = useAtomicStyles();
  const merchantId = useCurrentMerchantId();
  const dispatch = useDispatch();

  const merchantsOptions = useSelector(selectors.getMerchantsList).map(
    (merchant) => ({
      value: merchant._id,
      label: merchant.name,
    }),
  );
  const [t] = useTypedTranslations();

  const handleMerchantChange = useCallback(
    (event) => {
      const newId = event.target.value;
      dispatch(push(`/merchants/${newId}/events/`));
    },
    [dispatch],
  );

  const handleLogout = useCallback(() => {
    dispatch(replace("/"));
    dispatch(actions.clearSession());
  }, [dispatch]);

  return {
    styles,
    classes,
    atomicStyles,
    merchantId,
    handleMerchantChange,
    merchantsOptions,
    handleLogout,
    t,
  };
};

export { useDashboardAppBar as default };
